import type { ItemSidebar } from '../_types';

import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';

import { Rocket, Home, ShoppingBasket, Truck, Package, Wallet, Megaphone, Settings, CircleHelp } from 'lucide-svelte';

export const showUnderConstructionModal = writable<boolean>(false);

export const sidebar: Writable<boolean> = writable(false);

export const currentSidebarParentActive: Writable<string | null> = writable(null);
export const currentSidebarChildActive: Writable<string | null> = writable(null);
export const currentSidebarSubChildActive: Writable<string | null> = writable(null);

export const sidebarParentActive: Writable<string | null> = writable(null);
export const sidebarChildActive: Writable<string | null> = writable(null);
export const sidebarSubChildActive: Writable<string | null> = writable(null);

export const sidebarMenu: Writable<ItemSidebar[]> = writable([
	{
		id: 'get-started',
		usingDropdownItems: false,
		icon: Rocket,
		items: [
			{
				id: 'get-started',
				hasSubMenu: false,
				menu: 'Get Started',
				url: '/onboarding',
				subItems: []
			}
		]
	},
	{
		id: 'dashboard',
		usingDropdownItems: false,
		icon: Home,
		items: [
			{
				id: 'dashboard',
				hasSubMenu: false,
				menu: 'Dashboard',
				url: '/dashboard-new',
				subItems: []
			}
		]
	},
	{
		id: 'penjualan',
		usingDropdownItems: true,
		icon: ShoppingBasket,
		items: [
			{
				id: 'daftar-penjualan',
				hasSubMenu: false,
				menu: 'Daftar Penjualan',
				url: '/orders',
				subItems: []
			},
			{
				id: 'data-pelanggan',
				hasSubMenu: false,
				menu: 'Data Pelanggan',
				url: '/orders/customers',
				subItems: []
			}
		]
	},
	{
		id: 'pengiriman',
		usingDropdownItems: false,
		icon: Truck,
		items: [
			{
				id: 'pengiriman',
				hasSubMenu: false,
				menu: 'Pengiriman',
				url: '/shipping',
				subItems: []
			}
		]
	},
	{
		id: 'persediaan',
		usingDropdownItems: true,
		icon: Package,
		items: [
			{
				id: 'daftar-gudang',
				hasSubMenu: false,
				menu: 'Daftar Gudang',
				url: '/inventory/warehouses',
				subItems: []
			},
			{
				id: 'daftar-produk',
				hasSubMenu: false,
				menu: 'Daftar Produk',
				url: '/inventory/products',
				subItems: []
			},
			{
				id: 'daftar-kategori-produk',
				hasSubMenu: false,
				menu: 'Daftar Kategori Produk',
				url: '/inventory/categories',
				subItems: []
			},
			{
				id: 'laporan-usia-produk',
				hasSubMenu: false,
				menu: 'Laporan Usia Produk',
				url: '/inventory/reports/product-age',
				subItems: []
			},
			{
				id: 'stok-opname-produk',
				hasSubMenu: false,
				menu: 'Stok Opname Produk',
				url: '/inventory/stock-opname',
				subItems: []
			}
		]
	},
	{
		id: 'keuangan',
		usingDropdownItems: true,
		icon: Wallet,
		items: [
			{
				id: 'buku-besar-parent',
				hasSubMenu: true,
				menu: 'Buku Besar',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'jurnal-umum',
						menu: 'Jurnal Umum',
						url: '/finance/journals'
					},
					{
						id: 'buku-besar',
						menu: 'Buku Besar',
						url: '/finance/ledgers'
					}
				]
			},
			{
				id: 'penjualan-keuangan',
				hasSubMenu: true,
				menu: 'Penjualan',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'faktur-penjualan',
						menu: 'Faktur Penjualan',
						url: '/finance/sale-invoices'
					},
					{
						id: 'retur-penjualan',
						menu: 'Retur Penjualan',
						url: '/finance/sale-returns'
					}
				]
			},
			{
				id: 'pembelian',
				hasSubMenu: true,
				menu: 'Pembelian',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'faktur-pembelian',
						menu: 'Faktur Pembelian',
						url: '/finance/purchase-invoices'
					},
					{
						id: 'retur-pembelian',
						menu: 'Retur Pembelian',
						url: '/finance/purchase-invoice-returns'
					},
					{
						id: 'daftar-utang-usaha',
						menu: 'Daftar Utang Usaha',
						url: '/finance/account-payables'
					},
					{
						id: 'pembayaran-utang-usaha',
						menu: 'Pembayaran Utang Usaha',
						url: '/finance/payable-payments'
					},
					{
						id: 'penerimaan-lebih-bayar',
						menu: 'Penerimaan Lebih Bayar',
						url: '/finance/vendor-debit-refunds'
					}
				]
			},
			{
				id: 'kas-bank',
				hasSubMenu: true,
				menu: 'Kas & Bank',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'pengeluaran',
						menu: 'Pengeluaran',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'uang-muka-pengeluaran',
						menu: 'Uang Muka Pengeluaran',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'penerimaan',
						menu: 'Penerimaan',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'uang-muka-penerimaan',
						menu: 'Uang Muka Penerimaan',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'transfer-kas',
						menu: 'Transfer Kas',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'rekonsiliasi-bank',
						menu: 'Rekonsiliasi Bank',
						url: 'javascript:void(0)',
						underConstruction: true
					}
				]
			},
			{
				id: 'harta-tetap',
				hasSubMenu: true,
				menu: 'Harta Tetap',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'data-harta-tetap',
						menu: 'Data Harta Tetap',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'penyusutan-harta-tetap',
						menu: 'Penyusutan Harta Tetap',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'perubahan-nilai-aset',
						menu: 'Perubahan Nilai Aset',
						url: 'javascript:void(0)',
						underConstruction: true
					}
				]
			},
			{
				id: 'laporan',
				hasSubMenu: true,
				menu: 'Laporan',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'laporan-neraca',
						menu: 'Laporan Neraca',
						url: '/finance/balance-sheets'
					},
					{
						id: 'laporan-laba-rugi',
						menu: 'Laporan Laba Rugi',
						url: '/finance/income-statement'
					},
					{
						id: 'laporan-arus-kas',
						menu: 'Laporan Arus Kas',
						url: '/finance/cash-flow'
					},
					{
						id: 'laporan-perubahan-modal',
						menu: 'Laporan Perubahan Modal',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'periode-tutup-buku',
						menu: 'Periode Tutup Buku',
						url: '/finance/close-accounting-period'
					}
				]
			}
			// {
			// 	id: 'faktur-pembayaran',
			// 	hasSubMenu: false,
			// 	menu: 'Faktur Pembayaran',
			// 	url: '/finance/payment-invoices'
			// },
		]
	},
	{
		id: 'marketing',
		usingDropdownItems: true,
		icon: Megaphone,
		items: [
			{
				id: 'marketplace',
				hasSubMenu: false,
				underConstruction: true,
				menu: 'Marketplace',
				url: 'javascript:void(0)',
				subItems: []
			},
			{
				id: 'laporan-iklan',
				hasSubMenu: false,
				menu: 'Laporan Iklan',
				url: '/report/ads',
				subItems: []
			}
		]
	},
	{
		id: 'pengaturan',
		usingDropdownItems: true,
		icon: Settings,
		items: [
			{
				id: 'penjualan-pengaturan',
				hasSubMenu: true,
				menu: 'Penjualan',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'kanal-penjualan',
						menu: 'Kanal Penjualan',
						url: '/sales/channels'
					},
					{
						id: 'metode-pengiriman',
						menu: 'Metode Pengiriman',
						url: '/sales/shippings'
					},
					{
						id: 'metode-pembayaran',
						menu: 'Metode Pembayaran',
						url: '/sales/payment-methods'
					},
					{
						id: 'pengaturan-pajak',
						menu: 'Pengaturan Pajak',
						url: '/sales/tax-settings'
					}
				]
			},
			{
				id: 'keuangan',
				hasSubMenu: true,
				menu: 'Keuangan',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'daftar-klasifikasi-akun',
						menu: 'Daftar Klasifikasi Akun',
						url: '/finance/settings/account-classifications'
					},
					{
						id: 'daftar-akun',
						menu: 'Daftar Akun',
						url: '/finance/settings/accounts'
					},
					{
						id: 'saldo-awal-akun',
						menu: 'Saldo Awal Akun',
						url: '/finance/settings/accounts/balance'
					},
					{
						id: 'kpi-akun',
						menu: 'KPI Akun',
						url: '/finance/settings/accounts-kpi'
					},
					{
						id: 'daftar-bank',
						menu: 'Daftar Bank',
						url: '/finance/settings/banks'
					},
					{
						id: 'pengaturan-akun',
						menu: 'Pengaturan Akun',
						url: '/finance/settings/general-settings'
					},
					{
						id: 'daftar-pemasok',
						menu: 'Daftar Pemasok',
						url: '/finance/settings/suppliers'
					}
				]
			},
			{
				id: 'integrasi',
				hasSubMenu: true,
				menu: 'Integrasi',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'marketplace',
						menu: 'Marketplace',
						url: '/integration/marketplace'
					},
					{
						id: 'iklan-berbayar',
						menu: 'Iklan Berbayar',
						url: 'javascript:void(0)',
						underConstruction: true
					},
					{
						id: 'pos',
						menu: 'POS',
						url: '/integration/pos'
					},
					{
						id: 'whatsapp',
						menu: 'Whatsapp',
						url: '/integration/whatsapp'
					},
					{
						id: 'pengaturan-kanal',
						menu: 'Pengaturan Kanal',
						url: '/integration/channel-settings'
					}
				]
			},
			{
				id: 'aplikasi',
				hasSubMenu: true,
				menu: 'Aplikasi',
				url: 'javascript:void(0)',
				subItems: [
					{
						id: 'pengguna-hak-akses',
						menu: 'Pengguna & Hak Akses',
						url: '/settings/employees'
					},
					{
						id: 'profil',
						menu: 'Profil',
						url: '/settings/profiles'
					}
				]
			}
		]
	},
	{
		id: 'pusat-bantuan',
		usingDropdownItems: false,
		hasBorder: true,
		icon: CircleHelp,
		items: [
			{
				id: 'pusat-bantuan',
				hasSubMenu: false,
				menu: 'Pusat Bantuan',
				outsideUrl: true,
				url: 'https://docs.semudahitu.id',
				subItems: []
			}
		]
	}
]);

export const underConstruction = () => {
	showUnderConstructionModal.set(true);
};
